import { useTranslation } from "react-i18next";
import { NS, type Namespace } from "@core/libs/i18n/namespaces";

export const useTranslate = (namespace?: Namespace) => {
  const { t: baseT, i18n } = useTranslation(namespace ?? NS.COMMON);

  const t = (key: string, opts?: Record<string, unknown>) => baseT(key as never, opts) as string;

  return { t, i18n };
};
